import { render, staticRenderFns } from "./addHousekeepingFeeConfig.vue?vue&type=template&id=7f591792"
import script from "./addHousekeepingFeeConfig.vue?vue&type=script&lang=js"
export * from "./addHousekeepingFeeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports